import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Error } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslate } from '@refinedev/core';

const ErrorPage: React.FC = () => {
  const translate = useTranslate();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        py: 8,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          textAlign: 'center',
        }}
      >
        <Error sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom color="error">
          {translate('payment.error.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {translate('payment.error.message')}
          <br />
          {translate('payment.error.instruction')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="outlined"
            onClick={() => navigate('/pricing')}
          >
            {translate('payment.error.actions.backToPricing')}
          </Button>
          <Button
            variant="contained"
            onClick={() => window.location.reload()}
          >
            {translate('payment.error.actions.tryAgain')}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ErrorPage;
